<template>
    <el-drawer
        title="编辑学生"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="700px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="姓名">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="家长姓名">
                    <el-input v-model="form.parentName"></el-input>
                </el-form-item>
                <el-form-item label="学校">
                    <el-input v-model="form.school"></el-input>
                </el-form-item>
                <el-form-item label="登录密码">
                    <div class="fx">
                        <el-popconfirm @onConfirm="resetPwd()"
                                       title="确认重置该用户密码吗？"
                        >
                            <el-button slot="reference" type="primary" size="small" style="margin-right: 20px">重置密码</el-button>
                        </el-popconfirm>

                        <span class="text_info tr">*密码将重置为123456</span>
                    </div>

                </el-form-item>
            </el-form>


        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
    .edit_form {
        margin-top: 20px;
        width: 88%;
    }
</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                form: this.item,
            }

        },


        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                let data = this.form;
                this.$ajaxPost("/user/save", {
                    user: this.form
                }, (data) => {
                    this.$emit("submit", data.result);
                })
                return false;
            },
            resetPwd() {
                this.$ajaxGet("/user/resetPassword/"+this.item.id, (data) => {
                    this.$showSuccess("重置成功");
                })
            }
        },
        mounted() {
            this.show = true;
        },
        created() {

        }


    }
</script>
